const COMPANIES = {
    'trasporti-flli-primiceri': {
        slug: 'trasporti-flli-primiceri',
        name: 'Trasporti F.lli Primiceri s.r.l.',
        place: 'Lecce',
        phone: '',
        mail: 'primiceri@greenplanetlogistics.net',
        pec: '',
        website: 'www.trasportiprimiceri.it',
        fullAddress: 'SP 33, 73042 Casarano (Le)',
        logo: 'gpl/companies/primiceri.png',
        social: {
            linkedin: 'https://ke.linkedin.com/company/trasporti-f.lli-primiceri',
            instagram: 'https://www.instagram.com/trasporti_f.lli_primiceri/',
            facebook: 'https://www.facebook.com/primiceritrasporti',
            twitter: '',
        },
        quotation: {
            position: 'CEO',
            name: 'Sonia Primiceri',
            text: '"La vostra soddisfazione è la nostra destinazione"',
            picture: 'gpl/companies/sonia-primiceri.jpg',
            visible: false,
        },
        content: '/companies/primiceri.html',
        certifications: [
            'ISO 9001.2015',
            'HCCP',
            'ADR',
            'Modello 231',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Trasporti Internazionali',
            'Trasporti Intermodali',
            'Servizio espresso su pedana',
            'Servizi di collettame',
            'Carichi completi',
        ],
        stats: {
            veichles: 87,
            drivers: 58,
            infrastructures: 3.5,
        },
        partners: [
            {
                img: 'gpl/companies/palletways.png',
                altImg: 'Palletways',
            },
            {
                img: 'gpl/companies/cds.png',
                altImg: 'Gruppo CDS',
            },
        ],
    },
    'bs-group-srl': {
        slug: 'bs-group-srl',
        name: 'BS-Group s.r.l.',
        place: 'Teramo',
        phone: '+39 0861.856236',
        mail: 'bsgroup@greenplanetlogistics.net',
        pec: '',
        website: 'www.bs-group.it',
        fullAddress: 'Via Torino 235 63074 S.Benedetto del Tronto (AP)',
        logo: 'gpl/companies/bs-gro.png',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: 'gpl/user.png',
            visible: false,
        },
        content: '/companies/bs-group.html',
        certifications: [
            'ISO 9001.2015',
            'HCCP',
            'ADR',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Carichi completi',
            'Servizio espresso su pedana',
            'Servizi di collettame',
        ],
        stats: {
            veichles: 58,
            drivers: 50,
            infrastructures: 6,
        },
        partners: [
            {
                img: 'gpl/companies/palletways.png',
                altImg: 'Palletways',
            },
            {
                img: 'gpl/companies/cds.png',
                altImg: 'Gruppo CDS',
            },
        ],
    },
    'trial-srl': {
        slug: 'trial-srl',
        name: 'Trial s.r.l.',
        place: 'Milano',
        phone: '333 9321774',
        mail: 'c.fraconti@greenplanetlogistics.net',
        pec: '',
        website: 'www.trialsrl.com',
        fullAddress: 'Viale T. Edison, 637 - 20099 Sesto San Giovanni (MI)',
        logo: 'gpl/companies/trial.png',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: 'gpl/user.png',
            visible: false,
        },
        content: '/companies/trial-srl.html',
        certifications: [
            'ISO 9001.2015',
            'Rating Legalità',
            'White List',
            'TAPA',
            'HCCP',
            'HCCP Mangimi',
            'ADR',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Trasporti Internazionali',
            'Carichi completi',
            'Servizio espresso su pedana',
            'Trasporti Speciali',
        ],
        stats: {
            veichles: 45,
            drivers: 15,
            infrastructures: 1.3,
        },
        partners: [
            {
                img: 'gpl/companies/palletways.png',
                altImg: 'Palletways',
            },
            {
                img: 'gpl/companies/cds.png',
                altImg: 'Gruppo CDS',
            },
            {
                img: 'gpl/companies/pallex.png',
                altImg: 'Pallex',
            },
        ],
    },
    'palladino-logistics-srl': {
        slug: 'palladino-logistics-srl',
        name: 'Palladino Logistics s.r.l.',
        place: 'Avellino',
        phone: '+39 0825 610020',
        mail: 'palladino@greenplanetlogistics.net',
        pec: '',
        website: 'www.palladinotrasporti.com',
        fullAddress: 'Contrada Pianodardine, 83100 Avellino (AV)',
        logo: 'gpl/companies/palladino.jpeg',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: 'gpl/user.png',
            visible: false,
        },
        content: '/companies/palladino-logistics.html',
        certifications: [
            'ISO 9001.2015',
            'White List',
            'HCCP',
            'HCCP Mangimi',
            'ADR',
            'Modello 231',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Trasporti Internazionali',
            'Carichi completi',
            'Servizio espresso su pedana',
        ],
        stats: {
            veichles: 232,
            drivers: 75,
            infrastructures: 2.6,
        },
        partners: [
            {
                img: 'gpl/companies/palletways.png',
                altImg: 'Palletways',
            },
        ],
    },
    'iorio-trasporti-e-logistica-spa': {
        slug: 'iorio-trasporti-e-logistica-spa',
        name: 'Iorio Trasporti e Logistica SpA',
        place: 'Napoli',
        phone: '+39 0823.14.43.161',
        mail: 'iorio@greenplanetlogistics.net',
        pec: '',
        website: 'www.ioriotrasportielogistica.it',
        fullAddress: 'Via San Giacomo, 40 80133 - Napoli',
        logo: 'gpl/companies/iorio.png',
        social: {
            linkedin: 'https://it.linkedin.com/company/iorio-trasporti-e-logistica-spa',
            instagram: '',
            facebook: 'https://www.facebook.com/IorioTrasportiELogistica/',
        },
        quotation: {
            position: 'CEO',
            name: 'Angelo Iorio',
            text: '"Aderire ad un gruppo che punta sulla green economy facendo squadra e condividendo lo stesso principio di innovazione e sostenibilità, diventa la ricetta ideale per un futuro progressista e longevo"',
            picture: 'gpl/companies/iorio-ceo.jpg',
            visible: false,
        },
        content: '/companies/iorio.html',
        certifications: [
            'ISO 9001.2015',
            'White List',
            'HCCP',
            'HCCP Mangimi',
            'ADR',
        ],
        services: [
        ],
        stats: {
            veichles: 160,
            drivers: 62,
            infrastructures: 3.5,
        },
        partners: [
        ],
    },
    'so-log-srl': {
        slug: 'so-log-srl',
        name: 'So.Log s.r.l.',
        place: 'Sondrio',
        phone: '',
        mail: 'solog@greenplanetlogistics.net',
        pec: '',
        website: 'www.solog.it',
        fullAddress: '',
        logo: 'gpl/companies/solog.jpg',
        social: {
            linkedin: '',
            instagram: '',
            facebook: 'https://www.facebook.com/sologtrasportielogistica/',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: 'gpl/user.png',
            visible: false,
        },
        content: '/companies/so-log-srl.html',
        certifications: [
            'ISO 9001.2015',
            'ECOVADIS',
            'RATING LEGALITA',
            'HACCP',
            'HACCP MANGIMI',
            'ADR',
            'WHITE LIST',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Trasporti Intermodali',
            'Carichi completi',
            'Servizio espresso su pedana',
            'Servizi di collettame',
        ],
        stats: {
            veichles: 213,
            drivers: 70,
            infrastructures: 1.5,
        },
        partners: [
            {
                img: 'gpl/companies/palletways.png',
                altImg: 'Palletways',
            },
        ],
    },
    'lanzi-trasporti-srl': {
        slug: 'lanzi-trasporti-srl',
        name: 'Lanzi Trasporti s.r.l.',
        place: 'Parma',
        phone: '+39 0521 615021',
        mail: 'lanzi@greenplanetlogistics.net',
        pec: '',
        website: 'www.lanzitrasporti.it',
        fullAddress: 'Via Bonn 6, Interporto di Parma 43010 Bianconese di Fontevivo',
        logo: 'gpl/companies/Lanzi.png',
        social: {
            linkedin: 'https://www.linkedin.com/company/lanzi-trasporti-s.r.l./',
            instagram: '',
            facebook: 'https://www.facebook.com/lanzitrasporti/',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/lanzi.html',
        certifications: [
            'ISO 9001.2015',
            'Rating Legalità',
            'White List',
            'TAPA',
            'HCCP',
            'ADR',
        ],
        services: [
        ],
        stats: {
            veichles: 113,
            drivers: 25,
            infrastructures: 8.5,
        },
        partners: [
        ],
    },

    'mtl-montichiari-trasplog-srl': {
        slug: 'mtl-montichiari-trasplog-srl',
        name: 'M.T.L. Montichiari Trasp.Log. s.r.l.',
        place: 'Brescia',
        phone: '+39 030 9962004',
        mail: 'mtl@greenplanetlogistics.net',
        pec: '',
        website: 'https://www.mtllogistica.com/mtl-logistica/la-storia/',
        fullAddress: 'Via Fermi, 56 - Montichiari (BS)',
        logo: 'gpl/companies/mtl.png',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/mtl-trasporti.html',
        certifications: [
            'ISO 9001.2015',
            'Rating Legalità',
            'White List',
            'TAPA',
            'HCCP',
            'ADR',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Trasporti Internazionali',
            'Trasporto Intermodale',
            'Carichi completi',
            'Pallet espressi',
            'Trasporti speciali',
        ],
        stats: {
            veichles: 195,
            drivers: 59,
            infrastructures: 13.5,
        },
        partners: [
        ],
    },

    'rebasti-trasporti-sas': {
        slug: 'rebasti-trasporti-sas',
        name: 'Rebasti Trasporti s.a.s.',
        place: 'Nerviano',
        phone: '+39 335 7436388',
        mail: 'rebasti@greenplanetlogistics.net',
        pec: '',
        website: 'http://rebastitrasporti.it/Default.aspx?ReturnUrl=%2f',
        fullAddress: 'Via Sempione, 27 - 20014 Nerviano (MI)',
        logo: 'gpl/companies/Rebasti.jpg',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/rebasti-trasporti.html',
        // content: null,
        certifications: [
            'HACCP',
            'HACCP MANGIMI',
            'ADR',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Tasporti Internazionali',
            'Trasporto Intermodale',
            'Carichi completi',
            'Pallet espressi',
            'Trasporti speciali',
        ],
        stats: {
            veichles: 0,
            drivers: 0,
            infrastructures: 0,
        },
        partners: [
            {
                img: 'gpl/companies/palletways.png',
                altImg: 'Palletways',
            },
            {
                img: 'gpl/companies/cds.png',
                altImg: 'CDS',
            },
        ],
    },

    'racchetti-medio-trasporti': {
        slug: 'racchetti-medio-trasporti',
        name: 'Racchetti Medio Trasporti s.r.l.',
        place: 'Cremona',
        phone: '+39 0372 491021',
        mail: 'racchetti@greenplanetlogistics.net',
        pec: '',
        website: 'https://www.racchettitrasporti.com/',
        fullAddress: 'Via delle Viole, 35 - 26100 Cremona (CR)',
        logo: 'gpl/companies/racchetti.jpg',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/racchetti-medio-trasporti.html',
        // content: null,
        certifications: [
            'HACCP',
            'HACCP MANGIMI',
            'ADR',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Tasporti Internazionali',
            'Trasporto Intermodale',
            'Carichi completi',
            'Pallet espressi',
            'Trasporti speciali',
        ],
        stats: {
            veichles: 49,
            drivers: 17,
            infrastructures: 2,
        },
        partners: [
        ],
    },

    'bianchi-modena-srl': {
        slug: 'bianchi-modena-srl',
        name: 'Bianchi Modena s.r.l.',
        place: 'Modena',
        phone: '+39 031 566811',
        mail: 'bianchi@greenplanetlogistics.net',
        pec: '',
        website: 'https://www.bianchitrasporti-it.com/',
        fullAddress: 'Via dei Maniscalchi, 10/12 - 41012 Carpi (MO)',
        logo: 'gpl/companies/bianchi.jpg',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/bianchi-group.html',
        // content: null,
        certifications: [
            'HACCP',
            'ADR',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Tasporti Internazionali',
            'Trasporto Intermodale',
            'Carichi completi',
            'Pallet espressi',
            'Trasporti speciali',
        ],
        stats: {
            veichles: 0,
            drivers: 45,
            infrastructures: 4.5,
        },
        partners: [
            {
                img: 'gpl/companies/palletways.png',
                altImg: 'Palletways',
            },
            {
                img: 'gpl/companies/cds.png',
                altImg: 'CDS',
            },
        ],
    },
    'bordignon-trasporti-srl': {
        slug: 'bordignon-trasporti-srl',
        name: 'Bordignon Trasporti s.r.l.',
        place: 'Torino',
        phone: '+39 031 566811',
        mail: 'bordignon@greenplanetlogistics.net',
        pec: '',
        website: 'https://www.bordignon.team/',
        fullAddress: 'Via dei Maniscalchi, 10/12 - 41012 Carpi (MO)',
        logo: 'gpl/companies/bordignon.jpg',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/bordignon.html',
        // content: null,
        certifications: [
            'ISO 9001.2015',
            'Rating Legalità',
            'HCCP',
            'HCCP Mangimi',
            'ADR',
            'Modello 231',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Tasporti Internazionali',
            'Trasporto Intermodale',
            'Carichi completi',
            'Pallet espressi',
            'Trasporti speciali',
        ],
        stats: {
            veichles: 130,
            drivers: 36,
            infrastructures: 1,
        },
        partners: [
            {
                img: 'gpl/companies/pallex.png',
                altImg: 'Pallex',
            },
        ],
    },
    'vallin-autotrasporti-srl': {
        slug: 'vallin-autotrasporti-srl',
        name: 'Vallin Autorasporti s.r.l.',
        place: 'Vigevano',
        phone: '+39 031 566811',
        mail: 'vallin@greenplanetlogistics.net',
        pec: '',
        website: 'https://www.vallin.it/',
        fullAddress: 'Via Tortona, 34/10 - 27029 Bressana Bottarone (PV)',
        logo: 'gpl/companies/vallin.jpg',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/vallin.html',
        // content: null,
        certifications: [
            'ISO 9001.2015',
            'White List',
            'HCCP',
            'HCCP Mangimi',
            'ADR',
        ],
        services: [
            'Logistica',
            'Raccolta e distribuzione',
            'Tasporti Internazionali',
            'Trasporto Intermodale',
            'Carichi completi',
            'Pallet espressi',
            'Trasporti speciali',
        ],
        stats: {
            veichles: 30,
            drivers: 6,
            infrastructures: 1.3,
        },
        partners: [
            {
                img: 'gpl/companies/pallex.png',
                altImg: 'Pallex',
            },
        ],
    },
    'cff-coop': {
        slug: 'cff-coop',
        name: 'CFF Coop',
        place: 'Faenza',
        phone: '+39 0546 21155 ',
        mail: 'cff@greenplanetlogistics.net',
        pec: '',
        website: 'https://www.cffcoop.it/',
        fullAddress: 'Via Galileo Galilei, 35 – 48018 Faenza (RA)',
        logo: 'gpl/companies/cff.png',
        social: {
            linkedin: '',
            instagram: '',
            facebook: '',
        },
        quotation: {
            position: 'CEO',
            name: '',
            text: '""',
            picture: '',
            visible: false,
        },
        content: '/companies/cff.html',
        // content: null,
        certifications: [
            
        ],
        services: [
            'Facchinaggio',
            'Traslochi',
            'Trasporti',
            'Ambiente',
            'Intermodale',
        ],
        stats: {
            // veichles: 30,
            // drivers: 6,
            // infrastructures: 1.3,
        },
        partners: [
            {
                // img: 'gpl/companies/pallex.png',
                // altImg: 'Pallex',
            },
        ],
    },
};

export default COMPANIES;
